import FalconComponentCard from "components/common/FalconComponentCard";
import { Button, Col } from "react-bootstrap";
import ClaimsViewRequestDetails from "./ClaimsViewRequestDetails";
import paths from "routes/paths";
import BackButton from "components/common/custom/back-button";
import { useDispatch, useSelector } from "react-redux";
import {
  addValidationError,
  clearValidationErrors,
  handleResetClaimAll,
  handleResetCreateClaim,
  setHistoryModal,
} from "../config/claimSlice";
import { useEffect, useMemo, useState } from "react";
import { ageCalculator, getPathFromUrl, getToday } from "helpers/utils";
import {
  ClaimBatchCheck,
  CreateSingleClaim,
  GetAllHistoryLog,
  GetClaimCancelResponse,
  GetClaimEligibility,
  GetClaimPreauthorization,
  GetClaimRequest,
  GetClaimResponse,
  ViewClaim,
} from "../config/cliamApi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { cleanObjectExcept, isEmpty } from "features/preauthorization/utils";
import { toast } from "react-toastify";
import ClaimBatchCheckModal from "./create-claim/components/ClaimBatchCheckModal";
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice";
import { hideLoader, showLoader } from "config/loaderManager";
import ClaimMedicalHistoryModal from "./create-claim/components/ClaimMedicalHistoryModal";

const ClaimViewRequest = () => {
  const dispatch = useDispatch();
  const { labTestList } = useSelector((state) => state.preauthorization);
  const {
    validationErrors,
    stepFormData,
    viewClaimInfo,
    preauthorizationDiagnosis,
    viewClaimRes,
    viewClaimReq,
    viewClaimCancelRes,
    cliamServicesList,
    viewEligibility,
    viewPreauthRes,
    claimListData,
    practitionerListAdded,
    historyModalOpen,
  } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims"
  );
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const [activeKey, setActiveKey] = useState("services");
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [body, setBody] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [claimNo, setClaimNo] = useState(null);
  const [data, setData] = useState([]);
  const [currentClaimIndex, setCurrentClaimIndex] = useState(-1);
  const navigate = useNavigate();
  const { age } = ageCalculator(stepFormData?.birth_date);

  const isDental =
    stepFormData?.claim_type?.claim_types_name?.toLowerCase() === "dental";
  const isPharmacy =
    stepFormData?.claim_type?.claim_types_name?.toLowerCase() === "pharmacy";
  const isVision =
    stepFormData?.claim_type?.claim_types_name?.toLowerCase() === "vision";
  const isInstitutional =
    stepFormData?.claim_type?.claim_types_name === "Institutional";

  const admissionDate = stepFormData?.admission_date;
  const dischargeDate = stepFormData?.discharge_date;
  const isPrescription = stepFormData?.prescription;

  const { id } = useParams(); // from React Router
  const claimIdNumber = useMemo(() => Number(id), [id]);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const claimType = params.get("claim_type");

  // Sort claims by claimid
  const sortedClaims = useMemo(() => {
    if (!Array.isArray(claimListData)) return [];
    return [...claimListData].sort((a, b) => a.claimid - b.claimid);
  }, [claimListData]);

  const saveStatus =
    viewClaimInfo?.claim_status?.toLowerCase() === "error" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "ready to submit" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "in process" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "rejected" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "validation error" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "invalid" ||
    viewClaimInfo?.claim_status?.toLowerCase() === "cancelled";

  useEffect(() => {
    if (!sortedClaims.length || !id) return;

    const index = sortedClaims.findIndex((claim) => claim.claimfull_id === id);

    setCurrentClaimIndex(index);
  }, [location.pathname, sortedClaims]);
  // useEffect(() => {
  //   if (
  //     Array.isArray(practitionerListAdded) &&
  //     practitionerListAdded.length === 0 &&
  //     Array.isArray(preauthorizationDiagnosis) &&
  //     preauthorizationDiagnosis.length === 0 &&
  //     Array.isArray(cliamServicesList) &&
  //     cliamServicesList.length === 0
  //   ) {
  //     showLoader();
  //   } else {
  //     hideLoader();
  //   }
  // }, [practitionerListAdded, preauthorizationDiagnosis, cliamServicesList]);
  // const handlePrevious = () => {
  //   dispatch(handleResetCreateClaim());
  //   dispatch(handleResetAll({ check: "reset" }));

  //   if (
  //     currentClaimIndex > 0 &&
  //     cliamServicesList?.length === 0 &&
  //     preauthorizationDiagnosis?.length === 0 &&
  //     practitionerListAdded?.length === 0
  //   ) {
  //     const previousClaim = sortedClaims[currentClaimIndex - 1];
  //     navigate(
  //       `${paths.viewClaimRequest}/${previousClaim.claimfull_id}?claim_type=${previousClaim.claim_type}`
  //     );
  //   }
  // };

  // const handleNext = () => {
  //   dispatch(handleResetCreateClaim());
  //   dispatch(handleResetAll({ check: "reset" }));

  //   if (currentClaimIndex < sortedClaims.length - 1) {
  //     const nextClaim = sortedClaims[currentClaimIndex + 1];
  //     navigate(
  //       `${paths.viewClaimRequest}/${nextClaim.claimfull_id}?claim_type=${nextClaim.claim_type}`
  //     );
  //   }
  // };

  // useEffect(() => {
  //   dispatch(
  //     ViewClaim({
  //       claimid: id,
  //       claim_type: claimType,
  //     })
  //   );
  // }, [dispatch, id, claimType]);

  useEffect(() => {
    dispatch(
      GetAllHistoryLog({
        claimid: id,
        claim_type: claimType,
      })
    );
  }, [dispatch, id, claimType]);

  // useEffect(() => {
  //   const reqUrl = getPathFromUrl(viewClaimReq);
  //   const resUrl = getPathFromUrl(viewClaimRes);
  //   const preauthReq = getPathFromUrl(viewPreauthRes);
  //   const cancelRes = getPathFromUrl(viewClaimCancelRes);
  //   const eligibiltyUrl = getPathFromUrl(viewEligibility);

  //   if (reqUrl) {
  //     dispatch(GetClaimRequest(reqUrl));
  //   }
  //   if (resUrl) {
  //     dispatch(GetClaimResponse(resUrl));
  //   }
  //   if (eligibiltyUrl) {
  //     dispatch(GetClaimEligibility(eligibiltyUrl));
  //   }
  //   if (cancelRes) {
  //     dispatch(GetClaimCancelResponse(cancelRes));
  //   }
  //   if (preauthReq) {
  //     dispatch(GetClaimPreauthorization(preauthReq));
  //   }
  // }, [
  //   dispatch,
  //   id,
  //   claimType,
  //   viewClaimReq,
  //   viewClaimRes,
  //   viewPreauthRes,
  //   viewClaimCancelRes,
  //   viewEligibility,
  // ]);

  const buildRequestBody = ({
    stepFormData,
    selectedBranch,
    attachements,
    practitionerListAdded,
    preauthorizationDiagnosis,
    labTestList,
    cliamServicesList,
    isDental,
    isPharmacy,
    isPrescription,
    isSubmit,
  }) => {
    const buildEyePrescription = (side, type) => {
      const suffix = `_${type}`;
      const eyeLabel = side;

      const getField = (key) => stepFormData?.[`${side}_${key}${suffix}`] || "";
      const power = getField("power");
      const sphere = getField("sph");
      if (!power && !sphere) {
        return;
      }

      const prismValues = [
        { amount: parseFloat(getField("in")) || "", base: "in" },
        { amount: parseFloat(getField("out")) || "", base: "out" },
        { amount: parseFloat(getField("down")) || "", base: "down" },
        { amount: parseFloat(getField("up")) || "", base: "up" },
      ].filter((p) => p.amount !== "" && p.amount !== 0);

      const prescription = {
        eye: eyeLabel,
        sphere: getField("sph"),
        cylinder: getField("cyl"),
        axis: getField("axis"),
        add: stepFormData?.[`${side}_add`] || "",
        brand: stepFormData?.[`${side}_brand`] || "",
        color: stepFormData?.[`${side}_color`] || "",
        power: getField("power"),
        duration: stepFormData?.[`${side}_duration_value`] || "",
        duration_typ: stepFormData?.[`${side}_duration_unit`] || "",
        bckcurve: getField("backcurve"),
        dmeter: getField("diameter"),
        prism: stepFormData?.productType === "lens" ? prismValues : [],
      };

      // Only add note if any of the "optical" fields are filled
      const hasNoteField = [
        prescription.sphere,
        prescription.power,
        prescription.cylinder,
        prescription.axis,
        ...prismValues.map((p) => p.amount),
        prescription.bckcurve,
        prescription.dmeter,
      ].some((val) => val !== "" && val !== undefined && val !== "");

      if (hasNoteField) {
        prescription.note = [{ text: type }];
      }

      // Remove if all values are ""/empty
      const hasRealData = Object.entries(prescription).some(([key, val]) => {
        if (key === "eye") return false;
        if (Array.isArray(val)) return val.length > 0;
        return val !== "" && val !== undefined && val !== "";
      });

      return hasRealData ? prescription : "";
    };

    let prescp = {};
    if (isVision) {
      prescp = {
        lens_typ: stepFormData?.productType || "",
        prescp_dte:
          stepFormData?.productType && stepFormData?.optical_date
            ? moment(stepFormData?.optical_date).format("YYYY-MM-DD")
            : "",
        isframe:
          stepFormData?.productType === "lens" ? stepFormData?.is_frame : false,
        regular_lenses: stepFormData?.regularLenses,
        lens_specifications:
          stepFormData?.productType === "lens"
            ? stepFormData?.lens_specifications?.map((item) => item?.value)
            : "",
        regular_contact:
          stepFormData?.productType === "contact"
            ? stepFormData?.regular_contact
            : "",
      };

      const allPrescriptions = [
        buildEyePrescription("right", "distance"),
        buildEyePrescription("right", "near"),
        buildEyePrescription("left", "distance"),
        buildEyePrescription("left", "near"),
      ];

      let presIndex = 1;
      allPrescriptions.forEach((entry) => {
        if (entry) {
          prescp[presIndex.toString()] = entry;
          presIndex++;
        }
      });
    } else {
      // Clear all vision-related fields if not vision claim
      prescp = {};
    }

    const sup_info = {
      18: { vreas: stepFormData?.visit_reason?.visitreas_code || "" },
      17: { chfcmp: { code: stepFormData?.chief_complaint || "" } },
      19: {
        invres: {
          code:
            stepFormData?.investigation_result?.investreslttype_code || null,
          oth:
            stepFormData?.investigation_result?.investreslttype_code === "other"
              ? stepFormData?.investigation_result_others
              : "",
          contentType:
            stepFormData?.investigation_result?.investreslttype_code === "IRA"
              ? stepFormData?.investgation_result_attachment?.contentType
              : "",
          title:
            stepFormData?.investigation_result?.investreslttype_code === "IRA"
              ? stepFormData?.investgation_result_attachment?.title
              : "",
          creation:
            stepFormData?.investigation_result?.investreslttype_code === "IRA"
              ? stepFormData?.investgation_result_attachment?.creation
              : "",
          data:
            stepFormData?.investigation_result?.investreslttype_code === "IRA"
              ? stepFormData?.investgation_result_attachment?.data
              : "",
        },
      },
      20: { trtpln: stepFormData?.treatment_plan || "" },
      21: { pathistry: stepFormData?.patient_history || "" },
      22: { phyexmn: stepFormData?.physical_examination || "" },
      23: { histrypreill: stepFormData?.history_present_illness || "" },
      1: { systlc: stepFormData?.systolic_blood_pressure || "" },
      2: { diastlc: stepFormData?.diastolic_blood_pressure || "" },
      3: { wgt: stepFormData?.weight || "" },
      4: { hgt: stepFormData?.height || "" },
      5: { temp: stepFormData?.temperature || "" },
      10: { oxystrn: stepFormData?.oxygen_saturation || "" },
      12: { resprte: stepFormData?.respiratory_rate || "" },
      8: { plse: stepFormData?.pulse || "" },
      11: { brthwgt: stepFormData?.birth_weight || "" },
      6: {
        menstprd: stepFormData?.last_menstrual_code
          ? moment(stepFormData?.last_menstrual_code).format("YYYY-MM-DD")
          : "" || "",
      },
      7: { icuhrs: stepFormData?.icu_hours || "" },
      9: { vnthrs: stepFormData?.ventilation_hours || "" },
      14: {
        empimp: {
          stdate: stepFormData?.empoly_impact_start_date
            ? moment(stepFormData?.empoly_impact_start_date).format(
              "YYYY-MM-DD"
            )
            : "",
          eddate: stepFormData?.empoly_impact_end_date
            ? moment(stepFormData?.empoly_impact_end_date).format("YYYY-MM-DD")
            : "",
        },
      },
      15: { addinfo: stepFormData?.additional_information || "" },
      24: { admnwgt: stepFormData?.admission_weight || "" },
      13: { lgthsty: stepFormData?.estimated_length_stay || "" },
      16: {
        aspcnd: {
          code: stepFormData?.aspect_of_condition?.icd_code || "",
          dte: stepFormData?.aspect_date
            ? moment(stepFormData?.aspect_date).format("YYYY-MM-DD")
            : "",
        },
      },
      25: {
        morplgy: {
          code: stepFormData?.diagnosis_morphology?.morphology_code || "",
        },
      },
      26: {
        msngtooth: {
          code: stepFormData?.missing_tooth_number?.oral_code || "",
          dte: stepFormData?.missing_tooth_date
            ? moment(stepFormData?.missing_tooth_date).format("YYYY-MM-DD")
            : "",
          resncde: stepFormData?.missing_reason?.msngtoothcde_code || "",
        },
      },
      27: {
        Snomed: stepFormData?.snomed_code?.snomedcde_code || "",
      },
    };

    const body = {
      branch_id: selectedBranch?.branch_id || selectedBranch?.value || "",
      insurance_company_id: stepFormData?.payer?.insurance_company_id,
      claim_type: stepFormData?.claim_type?.claim_types_id,
      claimsub_types_name: stepFormData?.claim_sub_type?.claimsub_types_id,
      process_prior: stepFormData?.priority_type?.prcspri_code,
      patient_eligbid: !stepFormData?.offline
        ? stepFormData?.online_eligibility_ref_no
        : "" || "",
      patient_preauthid: stepFormData?.patient_preauthid || "",
      preauth_ref:
        Array.from(
          new Set(
            cliamServicesList
              ?.map((item) => item?.preauthorization_ref_no)
              ?.filter((ref) => ref && ref.trim() !== "")
          )
        ).join(",") || "",
      prescp_no: stepFormData?.prescription_ref_no || "",
      patient_eligbdte: stepFormData?.patient_eligibility_date || "",
      patient_offeligbid: stepFormData?.offline
        ? stepFormData?.offline_eligibility_ref_no
        : "" || "",
      patient_offeligbdte: stepFormData?.offline
        ? stepFormData?.offline_eligibility_date
        : "" || "",
      preauthid: "",

      patient_clsnme: stepFormData?.class_name || "",
      patient_benf_finame: stepFormData?.child_first_name || "",
      patient_benf_faname: stepFormData?.child_family_name || "",
      reln_prior: stepFormData?.relation_relationship?.rltdrlshp_code || "",
      referral_req: stepFormData?.preauthorization_ref_no || "",
      prescript_submt: stepFormData?.prescription ? true : "",
      patient_offeligbdte: stepFormData?.offline_preauth_date
        ? moment(stepFormData?.offline_preauth_date).format("YYYY-MM-DD")
        : "",
      patient_natid: stepFormData?.id || "",
      patient_finame: stepFormData?.first_name || "",
      patient_faname: stepFormData?.family_name || "",
      patient_dob: stepFormData?.birth_date
        ? moment(stepFormData?.birth_date).format("YYYY-MM-DD")
        : "",
      patient_mrn: stepFormData?.patient_mrn || "",
      patient_benf_benf_type:
        stepFormData?.relation_id_type || stepFormData?.child_id_type || "",
      idenf_type: stepFormData?.identifier_type?.ident_type_id || "",
      patient_gender: stepFormData?.gender?.genders_code || "",
      patient_marital: stepFormData?.marital_status?.maritalstatus_code || "",
      patient_profession:
        stepFormData?.profession?.occup_code ||
        stepFormData?.occupation?.occup_code ||
        "",
      patient_memid: stepFormData?.membership_no || "",
      patient_benf_id: stepFormData?.relation_id || "",
      patient_mobileno: stepFormData?.mobile_no || "",
      accident_date: stepFormData?.accident_date
        ? moment(stepFormData?.accident_date).format("YYYY-MM-DD")
        : "",
      accident_type: stepFormData?.accident_type?.accdnttype_code || "",
      patient_tel: stepFormData?.mobile_no || "",
      accident_address:
        `${stepFormData?.address || ""}${stepFormData?.street_name || ""}${stepFormData?.city || ""
        }${stepFormData?.country || ""}` || "",
      patient_benf_gender:
        stepFormData?.relation_gender?.genders_code ||
        stepFormData?.child_gender?.genders_code ||
        "",
      patient_religion: stepFormData?.religion?.religion_code || "",
      patient_nationality: stepFormData?.nationality?.code || "",
      patient_ntwrk: stepFormData?.network || "",
      patient_plynum: stepFormData?.policy_no || "",
      clncldata: stepFormData?.clinical_data || "",
      claimbatch_no: claimNo || "",
      patient_benf_marital:
        stepFormData?.relation_marital_status?.maritalstatus_code || "",
      patient_benf_religion:
        stepFormData?.relation_religion?.religion_code || "",
      patient_benf_profession:
        stepFormData?.relation_occupation?.occup_code || "",
      patient_benf_mrn:
        stepFormData?.child_mrn || stepFormData?.relation_mrn || "",
      patient_benf_dob:
        stepFormData?.relation_birth_date || stepFormData?.child_birth_date
          ? moment(
            stepFormData?.relation_birth_date ||
            stepFormData?.child_birth_date
          ).format("YYYY-MM-DD")
          : "",
      patient_polcyholdr: stepFormData?.policy_holder_name || "",
      patient_polcyholdrnum: stepFormData?.policy_holder_number || "",
      othrconditions: stepFormData?.other_conditions || "",
      prescrptn_refno: stepFormData?.preauthorization_ref_no || "",
      claim_id: stepFormData?.claim_id || "",
      sgnfcntsign: stepFormData?.significant_sign || "",
      patient_relation: stepFormData?.relationship?.patrtl_code || "",
      patient_nwbrnrel: stepFormData?.new_born ? "child" : "",
      new_brn: stepFormData?.new_born ? true : "",
      enct_cls: stepFormData?.encounter_class?.act_code || "",
      claim_enctres: !isVision && !isPharmacy && !isPrescription ? "on" : "",
      sup_info,
      prescp,
      enct_stdate: stepFormData?.admission_date
        ? moment(stepFormData?.admission_date).format("YYYY-MM-DD HH:mm:ss")
        : "",
      enct_eddate: stepFormData?.discharge_date
        ? moment(stepFormData?.discharge_date).format("YYYY-MM-DD HH:mm:ss")
        : "",
      enct_serv_typ: stepFormData?.care_type?.enctalltyp_code || "",
      enct_prior: stepFormData?.act_priority?.enctalltyp_code || "",
      enct_emrgdeptdisp:
        stepFormData?.emer_department_disposition?.enctalltyp_code || "",
      enct_emrgarvlcde:
        stepFormData?.emergncy_arrival_code?.enctalltyp_code || "",
      enct_emergservst: stepFormData?.emergency_service_start_date
        ? moment(stepFormData?.emergency_service_start_date).format(
          "YYYY-MM-DD"
        )
        : "",
      enct_trgctg: stepFormData?.triage_category?.enctalltyp_code || "",
      mobile_no: stepFormData?.mobile_no || "",
      enct_trgdte: stepFormData?.triage_date
        ? moment(stepFormData?.triage_date).format("YYYY-MM-DD")
        : "",
      enct_hosp_intdlghsty:
        stepFormData?.intend_length_stay?.enctalltyp_code || "",
      enct_hosp_discgspeclty:
        stepFormData?.discharge_speciality?.specialities_code || "",
      enct_hosp_admnspeclty:
        stepFormData?.admission_speciality?.specialities_code || "",
      enct_adm_srce: stepFormData?.encounter_admitsource?.enctalltyp_code || "",
      enct_preadmn: stepFormData?.readmission?.enctalltyp_code || "",
      enct_disdisp: stepFormData?.discharge_disposition?.enctalltyp_code || "",
      enct_csedth: stepFormData?.cause_of_death?.code || "",
      enct_sevnttyp: stepFormData?.service_event_type?.enctalltyp_code || "",
      enct_status: stepFormData?.encounter_status?.enctalltyp_code || "",
      diag: {},
      prd_ser: {},
      sup_info_attch: {},
      sup_info_labt: {},
      sup_info_suply: {},
      claim_submit: isSubmit ? "claim_submit" : "",
      claim_presubmit: ["ready to submit", "invalid"].includes(
        viewClaimInfo?.claim_status?.toLowerCase()
      )
        ? false
        : true,
    };

    // Attachments
    if (Array.isArray(attachements)) {
      attachements.forEach((item, index) => {
        body.sup_info_attch[index + 1] = {
          contentType: item?.valueAttachment?.contentType || "",
          title: item?.valueAttachment?.title || "",
          creation: item?.valueAttachment?.creation || "",
          data: item?.valueAttachment?.data || "",
        };
      });
    }

    const extractedSupInfoFields = [];

    // Extract from sup_info
    Object.entries(sup_info || {}).forEach(([_, fieldGroup]) => {
      if (!fieldGroup || typeof fieldGroup !== "object") return;

      Object.entries(fieldGroup).forEach(([fieldKey, fieldValue]) => {
        let hasValue = false;

        if (
          typeof fieldValue === "object" &&
          fieldValue !== null &&
          !Array.isArray(fieldValue)
        ) {
          hasValue = Object.values(fieldValue).some(
            (v) =>
              v !== null &&
              v !== undefined &&
              (typeof v !== "string" || v.trim() !== "")
          );
        } else {
          hasValue =
            fieldValue !== null &&
            fieldValue !== undefined &&
            (typeof fieldValue !== "string" || fieldValue.trim() !== "");
        }

        if (hasValue) {
          extractedSupInfoFields.push(fieldKey);
        }
      });
    });

    // Add attachment titles to extractedSupInfoFields
    if (Array.isArray(attachements)) {
      attachements.forEach((item, index) => {
        const content = item?.valueAttachment || {};
        body.sup_info_attch[index + 1] = {
          contentType: content.contentType || "",
          title: content.title || "",
          creation: content.creation || "",
          data: content.data || "",
        };

        if (content.title && content.title.trim() !== "") {
          extractedSupInfoFields.push(content.title.trim());
        }
      });
    }

    // Practitioners
    if (
      Array.isArray(practitionerListAdded) &&
      practitionerListAdded.length > 0
    ) {
      const pract_id = {};
      practitionerListAdded.forEach((item, index) => {
        if (item.practitioner?.value) {
          const practitioner = {
            pract_id: item.practitioner.value.practitioner_id,
            pract_license: item.practitioner.value.practitioner_license,
            pract_name: `${item.practitioner.value.practitioner_title || ""} ${item.practitioner.value.practitioner_firstname || ""
              } ${item.practitioner.value.practitioner_familyname || ""}`.trim(),
            pract_finame:
              item?.practitioner?.value?.practitioner_firstname || "",
            pract_faname:
              item?.practitioner?.value?.practitioner_familyname || "",
            pract_spec: item?.practice?.label || "",
            pract_spec_code: item.practice?.value || "",
            role: item.role?.careroles_code || "",
          };
          if (!isEmpty(practitioner)) {
            pract_id[index + 1] = practitioner;
          }
        }
      });
      if (Object.keys(pract_id).length > 0) {
        body.pract_id = pract_id;
      }
    }

    // Diagnoses
    if (Array.isArray(preauthorizationDiagnosis)) {
      preauthorizationDiagnosis.forEach((item, index) => {
        const key = String(index + 1);
        body.diag[key] = {
          diag_code: item.code || "",
          diag_typ: item.type || "",
          on_adms: item.onAdmission || "",
          diag_onset: item?.condition_onset || "",
        };
      });
    }

    // Lab Tests
    if (Array.isArray(labTestList)) {
      labTestList.forEach((test, index) => {
        const labt = {
          code: test?.lab_test_code?.loinc_code || "",
          uom: test?.lab_test_code?.loinc_uom || "",
          qty: test?.quantity || "",
        };
        const key = String(index + 1);
        body.sup_info_labt[key] = labt;
      });
    }

    // Supplies
    if (Array.isArray(cliamServicesList)) {
      cliamServicesList.forEach((item, index) => {
        const key = String(index + 1);
        if (
          item.day_supply !== null &&
          item.day_supply !== undefined &&
          item.day_supply !== ""
        ) {
          body.sup_info_suply[key] = item.day_supply;
        }
      });
    }

    // Services
    if (Array.isArray(cliamServicesList)) {
      cliamServicesList.forEach((item, index) => {
        const key = String(index + 1);
        const supInfoSupplyValue = body.sup_info_suply?.[key];

        body.prd_ser[key] = {
          invoice_no: item?.invoice_no || "",
          prd_type: item?.service_type?.servtype_code || "",
          prd_code: item?.service_code_description?.prodserv_code || "",
          prd_descp_txt: item?.service_code_description?.prodserv_desc || "",
          prov_cde: item?.service_code_description?.provider_code || null,
          prd_url_txt: item?.service_code_description?.prdurl || "",
          prd_pri: item?.unit_price || "0",
          prd_qty: item?.quantity || "1",
          prd_namnt: item?.net_amount || "0",
          discnt: item?.discount || "0",
          prd_pshre: item?.patient_share || "0",
          diag_tax: item?.vat || "0",
          period: {
            start: item?.service_start_date
              ? moment(item?.service_start_date).format("YYYY-MM-DD")
              : "",
            end: item?.service_end_date
              ? moment(item?.service_end_date).format("YYYY-MM-DD")
              : "",
          },
          Sntfc_code: item?.scientific_code || "",
          strngth: item?.strength || "",
          slct_rsn: item?.selection_reason?.pharmselrsn_code || "",
          duration: {
            start: item?.start_date
              ? moment(item?.start_date).format("YYYY-MM-DD")
              : "",
            end: item?.end_date
              ? moment(item?.end_date).format("YYYY-MM-DD")
              : "",
            dur_time: item?.duration || "",
            dur_time_value: item?.durationType || "",
          },
          frequency: {
            frq: item?.frequency || "",
            frq_prd: item?.period_info || "",
            frq_time_value: item?.frequencyType || "",
          },
          dose: {
            dsg_prd: "",
            dsg_time_value: item?.dose || "",
            dsg_inst: item?.doseType,
          },
          ROA: item?.route?.ruteadmn_code || "",
          ROA_disp: item?.route?.ruteadmn_name || "",
          time_inst: item?.time_instruction?.time_instCode || "",
          time_inst_disp: item?.time_instruction?.time_instDisplay || "",
          refill_count: item?.refill_count || "",
          pat_inst: item?.patient_instruction || "",
          dosage_instruction: item?.dosage_instruction || "",
          prd_packg: item?.packaged || false,
          prd_mtrnty: item?.maternity || false,
          orl_reg_code: isDental ? item?.oral_origin?.oral_code : "",
          body_site: !isDental ? item?.body_site?.bodysite_code : "",
          orl_reg_subsite: item?.sub_site?.bodysubsite_code || "",
          nonstd_cde: "",
          nonstd_disp: "",
          pres_med: {
            type: item?.prescribed_medication_type?.servtype_code || "",
            code: item?.prescribed_medication_code?.prodserv_code || "",
            url: item?.prescribed_medication_code?.prdurl || "",
          },
          Sntfc_code_abs_rsn: item?.scientic_code_absence?.absrsn_code || "",
          Sntfc_code_abs_rsn_oth: item?.scientific_code_other_reason || "",
          pselrsn: item?.selection_reason?.pharmselrsn_code || "",
          pharsubs: item?.pharmacist_substitute?.subsrsn_code || "",
          preauth_ref: item?.preauthorization_ref_no || "",
          pharsubsrsn: item?.substitute_reason_other || "",
          pract: [
            item?.service_practitioner?.value?.practitioner?.value?.practitioner_license?.toString() ||
            item?.service_practitioner?.value?.practitioner_license?.toString() || ""

          ],
          supinfo: extractedSupInfoFields || [],
          diag: item?.diagnosis?.map((d) => d.code) || [],
          supinfo3:
            supInfoSupplyValue != null && supInfoSupplyValue !== ""
              ? [`Days Supply-${key}`]
              : [],
          supinfo1: item?.lab_tests?.map((t) => t?.loinc_code) || [],
        };
      });
    }

    return cleanObjectExcept(body, ["sup_info", "pract_id", "prd_ser.prd_url_txt"]);
  };

  const isNCHI = stepFormData?.insurance_company_id === 41;
  const isProfessionalEmer =
    stepFormData?.claim_type?.claim_types_name === "professional" &&
    stepFormData?.claim_sub_type?.claimsub_types_code === "Emergency";
  const isProfessionalOut =
    stepFormData?.claim_type?.claim_types_name?.toLowerCase() ===
    "professional" &&
    stepFormData?.claim_sub_type?.claimsub_types_code?.toLowerCase() === "op";
  const attachments = stepFormData?.attachments;
  const investigationAttachment = stepFormData?.investgation_result_attachment;

  const calculateTotalAttachmentSize = (
    attachments,
    investigationAttachment
  ) => {
    let totalSize = 0;

    // Calculate size for general attachments
    if (Array.isArray(attachments)) {
      attachments.forEach((item) => {
        const base64Data = item?.valueAttachment?.data || "";
        if (base64Data) {
          // Remove base64 prefix (e.g., "data:image/png;base64,") if present
          const base64String = base64Data.split(",")[1] || base64Data;
          const binaryString = atob(base64String);
          totalSize += binaryString.length;
        }
      });
    }

    // Calculate size for investigation result attachment
    const invBase64 = investigationAttachment?.data || "";
    if (invBase64) {
      const base64String = invBase64.split(",")[1] || invBase64;
      const binaryString = atob(base64String);
      totalSize += binaryString.length;
    }

    return totalSize;
  };
  const handleSaveSubmit = async (isSubmit) => {
    dispatch(clearValidationErrors());
    let shouldBlock = false;

    // NCHI-specific validations
    if (isNCHI) {
      if (stepFormData?.claim_type?.claim_types_name !== "Institutional") {
        dispatch(
          addValidationError({
            field: "preauthorization",
            message: "[CNHI Rule] Type must be Institutional",
          })
        );
        shouldBlock = true;
      }
      if (stepFormData?.claim_sub_type?.visitreas_name !== "InPatient") {
        dispatch(
          addValidationError({
            field: "preauthorization",
            message: "[CNHI Rule] Type must be Institutional",
          })
        );
        shouldBlock = true;
      }

      if (
        stepFormData?.visit_reason &&
        stepFormData?.visit_reason.visitreas_name !== "Referral"
      ) {
        dispatch(
          addValidationError({
            field: "Visit reason",
            message:
              "[CNHI Rule] Visit Reason must be referral, or leave it empty in case of emergency",
          })
        );
        shouldBlock = true;
      }

      if (
        stepFormData?.visit_reason?.visitreas_name === "Referral" &&
        stepFormData?.preauthorization_ref_no === ""
      ) {
        dispatch(
          addValidationError({
            field: "Preauthorization Ref No",
            message: "[CNHI Rule] Preauthorization Ref No Mandatory",
          })
        );
        shouldBlock = true;
      }
    }

    // Practitioner validations
    practitionerListAdded.forEach((practitioner, index) => {
      const entryNumber = index + 1;

      if (!practitioner.practitioner?.value?.practitioner_license) {
        dispatch(
          addValidationError({
            field: `Practitioner #${entryNumber}`,
            message: `[Validation] Practitioner is required in entry ${entryNumber}`,
          })
        );
        shouldBlock = true;
      }

      if (!practitioner.practice?.value) {
        dispatch(
          addValidationError({
            field: `Practice #${entryNumber}`,
            message: `[Validation] Practice is required in entry ${entryNumber}`,
          })
        );
        shouldBlock = true;
      }

      if (!practitioner.role?.careroles_code) {
        dispatch(
          addValidationError({
            field: `Role #${entryNumber}`,
            message: `[Validation] Role is required in entry ${entryNumber}`,
          })
        );
        shouldBlock = true;
      }
    });

    const primaryCount = practitionerListAdded.filter(
      (p) => p.role?.careroles_code?.toLowerCase() === "primary"
    ).length;

    if (primaryCount > 1) {
      dispatch(
        addValidationError({
          field: "Practitioner Roles",
          message: "[Validation] Only one primary practitioner allowed",
        })
      );
      shouldBlock = true;
    }

    if (practitionerListAdded?.length === 0) {
      dispatch(
        addValidationError({
          field: "Practitioner",
          message: "One Doctor Must be added",
        })
      );
      shouldBlock = true;
    }

    // Check for duplicate practitioners
    const practitionerIds = {};
    practitionerListAdded.forEach((p) => {
      const id = p.practitioner?.value?.practitioner_id;
      if (id) {
        practitionerIds[id] = (practitionerIds[id] || 0) + 1;
      }
    });

    const duplicates = Object.entries(practitionerIds)
      .filter(([_, count]) => count > 1)
      .map(([id]) => id);

    if (duplicates.length > 0) {
      dispatch(
        addValidationError({
          field: "Healthcare Practitioners",
          message: "[Validation] Duplicate practitioners detected",
        })
      );
      shouldBlock = true;
    }

    // Diagnosis validations
    const hasDiagnosis = preauthorizationDiagnosis?.length > 0;
    const hasPrincipalDiagnosis = preauthorizationDiagnosis?.some(
      (diagnosis) => diagnosis.type === "principal"
    );

    const principalsDiagnosis = preauthorizationDiagnosis?.filter(
      (item) => item?.type === "principal"
    );

    const PDXPrinciple = preauthorizationDiagnosis?.some(
      (item) => item.UnacceptPDx === "1" && item?.type === "principal"
    );

    const hasMorphology = stepFormData?.diagnosis_morphology;
    const accidentType = stepFormData?.accident_type?.accdnttype_code;
    const hasY96 = preauthorizationDiagnosis?.some((d) => d.code === "Y96");
    const hasRTADiag = preauthorizationDiagnosis?.some(
      (d) => d?.RTA_diag === "1"
    );

    if (stepFormData?.new_born) {
      const validBirthCodes = [
        "Z38.0",
        "Z38.1",
        "Z38.2",
        "Z38.3",
        "Z38.4",
        "Z38.5",
        "Z38.6",
        "Z38.7",
        "Z38.8",
      ];

      const hasValidBirthDiagnosis = preauthorizationDiagnosis?.some(
        (d) => d.type === "secondary" && validBirthCodes.includes(d.code)
      );

      if (!hasValidBirthDiagnosis) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "Birth Related diagnosis with type secondary is required when Newborn selected.",
          })
        );
        shouldBlock = true;
      }
    }

    const getPatientCode = (age) => {
      const { years, months, days } = age;

      if (years > 0) {
        if (years >= 100) return 300 + (years - 100);
        return 200 + years;
      } else if (months > 0) {
        return 100 + months;
      } else if (days > 0) {
        if (days <= 6) return days;
        const weeks = Math.floor(days / 7);
        if (weeks >= 1 && weeks <= 3) return 10 + weeks;
      }
      return 0;
    };

    const ageInfo = {
      years: age?.years || 0,
      months: age?.months || 0,
      days: age?.days || 0,
    };

    const patientCode = getPatientCode(ageInfo);

    if (!isInstitutional) {
      const invalidDiagnosisTypes = preauthorizationDiagnosis?.some(
        (d) => d.type === "admitting" || d.type === "discharge"
      );

      if (invalidDiagnosisTypes) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "Admitting/Discharge diagnosis types cannot be used in non-Institutional preauthorization",
          })
        );
        shouldBlock = true;
      }
    }

    if (hasY96 && accidentType !== "WPA") {
      dispatch(
        addValidationError({
          field: "accident_type",
          message: "Diagnosis code Y96 requires Workplace Accident (WPA) type",
        })
      );
      shouldBlock = true;
    }

    if (accidentType === "WPA" && !hasY96) {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message: "Workplace Accident (WPA) type must have Diagnosis code Y96",
        })
      );
      shouldBlock = true;
    }

    if (hasRTADiag && accidentType !== "MVA") {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message:
            "One of the Diagnosis (principal/Secondary) need reporting Accident type 'Motor Vehicle Accident'",
        })
      );
      shouldBlock = true;
    }

    const admissionDate = stepFormData?.admission_date;

    // ✅ Employee impact dates validation
    const empStart = stepFormData?.empoly_impact_start_date
      ? new Date(stepFormData?.empoly_impact_start_date)
      : null;
    const empEnd = stepFormData?.empoly_impact_end_date
      ? new Date(stepFormData?.empoly_impact_end_date)
      : null;

    if (empStart && empEnd) {
      empStart.setHours(0, 0, 0, 0);
      empEnd.setHours(0, 0, 0, 0);

      if (empEnd < empStart) {
        dispatch(
          addValidationError({
            field: "empoly_impact_end_date",
            message: "Employee impact end date must be on or after start date",
          })
        );
        shouldBlock = true;
      }
    }

    // ✅ Admission date within service start/end
    if (
      admissionDate &&
      Array.isArray(cliamServicesList) &&
      cliamServicesList.length > 0
    ) {
      let earliestStartDate = null;
      let latestEndDate = null;

      const normalizeDate = (d) => {
        if (!d) return null;

        if (d instanceof Date) {
          return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }

        if (typeof d === "string") {
          const parts = d.split("-");

          if (parts.length === 3) {
            if (parts[0].length === 4) {
              return new Date(
                parseInt(parts[0]),
                parseInt(parts[1]) - 1,
                parseInt(parts[2])
              );
            } else {
              return new Date(
                parseInt(parts[2]),
                parseInt(parts[1]) - 1,
                parseInt(parts[0])
              );
            }
          }
        }

        return null;
      };

      const admission = normalizeDate(admissionDate);
      const discharge = dischargeDate ? normalizeDate(dischargeDate) : null;

      cliamServicesList.forEach((service) => {
        const startDate = normalizeDate(service?.service_start_date);
        const endDate = normalizeDate(service?.service_end_date);

        console.log({ cliamServicesList });

        if (startDate) {
          if (!earliestStartDate || startDate < earliestStartDate) {
            earliestStartDate = startDate;
          }
        }

        if (endDate) {
          if (!latestEndDate || endDate > latestEndDate) {
            latestEndDate = endDate;
          }
        }
      });

      const formatDate = (date) =>
        date ? moment(date).format("DD-MM-YYYY") : "N/A";

      if (earliestStartDate && admission > earliestStartDate) {
        dispatch(
          addValidationError({
            field: "admission_date",
            message: `Admission date must be on or before the earliest service start date: ${formatDate(
              earliestStartDate
            )}`,
          })
        );
        shouldBlock = true;
      }

      if (discharge && latestEndDate && discharge < latestEndDate) {
        dispatch(
          addValidationError({
            field: "discharge_date",
            message: `Discharge date must be on or after the latest service end date: ${formatDate(
              latestEndDate
            )}`,
          })
        );
        shouldBlock = true;
      }
    }

    if (!hasRTADiag && accidentType === "MVA") {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message:
            "Motor Vehicle Accident (MVA) type must have Diagnosis related with Road Traffic Accident",
        })
      );
      shouldBlock = true;
    }

    if (PDXPrinciple) {
      const invalidDiagnosis = preauthorizationDiagnosis.find(
        (item) => item.UnacceptPDx === "1" && item?.type === "principal"
      );
      const diagnosisCode = invalidDiagnosis?.code || "Invalid Code";

      dispatch(
        addValidationError({
          field: "diagnosis",
          message: `Diagnosis code ${diagnosisCode} cannot be selected as Principal.`,
        })
      );
      shouldBlock = true;
    }

    if (!hasDiagnosis) {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message: "Please add at least one diagnosis",
        })
      );
      shouldBlock = true;
    } else if (!hasPrincipalDiagnosis) {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message: "One Diagnosis code with type Principal is required.",
        })
      );
      shouldBlock = true;
    } else if (principalsDiagnosis?.length > 1) {
      dispatch(
        addValidationError({
          field: "diagnosis",
          message: "Only One Diagnosis with Principle is allowed",
        })
      );
      shouldBlock = true;
    }

    if (hasMorphology) {
      const hasValidMorphCode = preauthorizationDiagnosis?.some(
        (d) =>
          (d.type === "principal" || d.type === "secondary") &&
          d?.Morph_Code === "1"
      );

      if (!hasValidMorphCode) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "Morphology related diagnosis code with type principal/secondary is required when Morphology Code given.",
          })
        );
        shouldBlock = true;
      }
    }

    preauthorizationDiagnosis?.forEach((diagnosis, index) => {
      const ageL = parseInt(diagnosis?.AgeL, 10);
      const ageH = parseInt(diagnosis?.AgeH, 10);
      const pationAType = diagnosis?.Atype === "2";
      const patienSType = diagnosis?.Stype === "2";
      const isMale = diagnosis?.sex === "1";
      const isFemale = diagnosis?.sex === "2";
      if (!diagnosis.condition_onset?.trim()) {
        dispatch(
          addValidationError({
            field: `diagnosis`,
            message: `Condition onset is required for diagnosis #${index + 1
              } (${diagnosis.code})`,
          })
        );
        shouldBlock = true;
      }
      if (!isNaN(ageL) && patientCode < ageL) {
        if (pationAType) {
          // toast.warn("This Diagnosis Cannot be used for patient this age.");
        } else {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message: "This Diagnosis Cannot be used for patient this age.",
            })
          );
          shouldBlock = true;
        }
      }

      if (!isNaN(ageH) && patientCode > ageH) {
        if (pationAType) {
          // toast.warn("This Diagnosis is rare to use with this patient age.");
        } else {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message: "This Diagnosis Cannot be used for patient this age.",
            })
          );
          shouldBlock = true;
        }
      }

      if (stepFormData?.gender?.genders_code === "male" && isFemale) {
        if (patienSType) {
          // toast.warn("This Diagnosis is rare to use with this patient Type.");
        } else {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message: "Diagnosis can't be used for Male patient",
            })
          );
          shouldBlock = true;
        }
      }

      if (stepFormData?.gender?.genders_code === "female" && isMale) {
        if (patienSType) {
          // toast.warn("This Diagnosis is rare to use with this patient Type.");
        } else {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message: "Diagnosis can't be used for Female patient",
            })
          );
          shouldBlock = true;
        }
      }
    });

    if (stepFormData?.aspect_of_condition && !stepFormData?.aspect_date) {
      dispatch(
        addValidationError({
          field: "aspect_date",
          message: "Aspect Start Date is Required",
        })
      );
      shouldBlock = true;
    }

    // Vision-specific validations (only if isVision)
    if (isVision) {
      const productType = stepFormData?.productType;

      const validateFieldPairs = (cylField, axisField) => {
        const cylValue = stepFormData?.[cylField];
        const axisValue = stepFormData?.[axisField];

        if ((cylValue && !axisValue) || (!cylValue && axisValue)) {
          dispatch(
            addValidationError({
              field: cylValue ? axisField : cylField,
              message: `Both ${cylField
                .split("_")
                .slice(1)
                .join(" ")} and ${axisField
                  .split("_")
                  .slice(1)
                  .join(" ")} must be provided together`,
            })
          );
          return false;
        }
        return true;
      };

      if (productType === "lens") {
        const hasAnySphere = [
          "left_sph_distance",
          "left_sph_near",
          "right_sph_distance",
          "right_sph_near",
        ].some((field) => stepFormData?.[field]);

        if (!hasAnySphere) {
          dispatch(
            addValidationError({
              field: "sph",
              message: "Sphere is required for at least one eye/distance",
            })
          );
          shouldBlock = true;
        }

        const cylinderAxisPairs = [
          ["left_cyl_distance", "left_axis_distance"],
          ["left_cyl_near", "left_axis_near"],
          ["right_cyl_distance", "right_axis_distance"],
          ["right_cyl_near", "right_axis_near"],
        ];

        for (const [cyl, axis] of cylinderAxisPairs) {
          const cylValue = stepFormData?.cyl;
          const axisValue = stepFormData?.axis;

          // If only one is filled → already handled by your validateFieldPairs()
          if (!validateFieldPairs(cyl, axis)) {
            shouldBlock = true;
          }

          const hasCylOrAxis = cylValue || axisValue;
          if (hasCylOrAxis) {
            // Get side and type from field name (e.g. "left_cyl_distance")
            const [side, , type] = cyl.split("_");
            const sphereField = `${side}_sph_${type}`;
            const powerField = `${side}_power_${type}`;

            const sphValue = stepFormData?.sphereField;
            const powerValue = stepFormData?.powerField;

            if (!sphValue) {
              dispatch(
                addValidationError({
                  field: sphereField, // or powerField
                  message: `Either Sphere  is required when Cylinder or Axis is provided (${side} ${type})`,
                })
              );
              shouldBlock = true;
            }
          }
        }

        const directions = ["in", "out", "up", "down"];
        const sides = ["left", "right"];
        const types = ["distance", "near"];

        for (const direction of directions) {
          for (const side of sides) {
            for (const type of types) {
              const dirField = `${side}_${direction}_${type}`;
              const sphField = `${side}_sph_${type}`;
              const dirValue = stepFormData?.[dirField];
              const sphValue = stepFormData?.[sphField];

              if (dirValue && !sphValue) {
                dispatch(
                  addValidationError({
                    field: sphField,
                    message:
                      "Sphere is required when directional prism is specified",
                  })
                );
                shouldBlock = true;
              }
            }
          }
        }
      }

      if (productType === "contact") {
        // POWER validation
        const hasAnyPower = [
          "left_power_distance",
          "left_power_near",
          "right_power_distance",
          "right_power_near",
        ].some((field) => !!stepFormData?.[field]);

        if (!hasAnyPower) {
          dispatch(
            addValidationError({
              field: "power",
              message: "Power is required for at least one eye/distance",
            })
          );
          shouldBlock = true;
        }

        // CYL + AXIS validation
        const cylinderAxisPairs = [
          ["left_cyl_distance", "left_axis_distance"],
          ["left_cyl_near", "left_axis_near"],
          ["right_cyl_distance", "right_axis_distance"],
          ["right_cyl_near", "right_axis_near"],
        ];

        for (const [cyl, axis] of cylinderAxisPairs) {
          const cylValue = stepFormData?.cyl;
          const axisValue = stepFormData?.axis;

          // If only one is filled → handled by validateFieldPairs
          if (!validateFieldPairs(cyl, axis)) {
            shouldBlock = true;
          }

          // Only check power if cyl or axis is non-empty/non-null
          const hasCylOrAxis =
            (cylValue != null && cylValue !== "") ||
            (axisValue != null && axisValue !== "");
          if (hasCylOrAxis) {
            const [side, , type] = cyl.split("_");
            const powerField = `${side}_power_${type}`;

            const powerValue = stepFormData?.powerField;

            if (powerValue == null || powerValue === "") {
              dispatch(
                addValidationError({
                  field: powerField,
                  message: `Power is required when Cylinder or Axis is provided (${side} ${type})`,
                })
              );
              shouldBlock = true;
            }
          }
        }

        // Backcurve and Diameter validation
        const directions = ["backcurve", "diameter"];
        const sides = ["left", "right"];
        const types = ["distance", "near"];

        for (const direction of directions) {
          for (const side of sides) {
            for (const type of types) {
              const dirField = `${side}_${direction}_${type}`;
              const powerField = `${side}_power_${type}`;
              const dirValue = stepFormData?.dirField;
              const powerValue = stepFormData?.powerField;

              // Only check power if backcurve or diameter is non-empty/non-null
              if (
                dirValue != null &&
                dirValue !== "" &&
                (powerValue == null || powerValue === "")
              ) {
                dispatch(
                  addValidationError({
                    field: powerField,
                    message: `Power is required when ${direction.charAt(0).toUpperCase() + direction.slice(1)
                      } is specified`,
                  })
                );
                shouldBlock = true;
              }
            }
          }
        }
      }
    }

    if (cliamServicesList?.length === 0) {
      dispatch(
        addValidationError({
          field: "services",
          message: "Please add at least one service",
        })
      );
      shouldBlock = true;
    }

    if (admissionDate && Array.isArray(cliamServicesList)) {
      const normalizedAdmission = new Date(admissionDate);
      normalizedAdmission.setHours(0, 0, 0, 0);

      const normalizedDischarge = dischargeDate
        ? new Date(dischargeDate)
        : null;
      if (normalizedDischarge) normalizedDischarge.setHours(0, 0, 0, 0);

      cliamServicesList.forEach((service, index) => {
        if (!service?.service_start_date) return;

        const serviceDate = new Date(service.service_start_date);
        serviceDate.setHours(0, 0, 0, 0);

        const isBeforeAdmission = serviceDate < normalizedAdmission;
        const isAfterDischarge =
          normalizedDischarge && serviceDate > normalizedDischarge;

        if (
          (isBeforeAdmission || isAfterDischarge) &&
          !isVision &&
          !isPharmacy
        ) {
          dispatch(
            addValidationError({
              field: `services[${index}].service_start_date`,
              message: normalizedDischarge
                ? "Service date must be between admission and discharge dates"
                : "Service date must be after admission date",
            })
          );
          shouldBlock = true;
        }
        if (!service?.invoice_no) {
          dispatch(
            addValidationError({
              field: `services`,
              message: "Invoice No is required",
            })
          );
          shouldBlock = true;
        }
        if (
          service?.service_type?.servtype_code === "itm_medcde" &&
          !service?.strength
        ) {
          setError("strength", {
            type: "validate",
            message: "Strength is required when service type is medical code ",
          });
          shouldBlock = true;
        }
        if (
          service?.service_type?.servtype_code === "itm_hrblcde" &&
          !service?.strength
        ) {
          setError("strength", {
            type: "validate",
            message: "Strength is required when service type is Herbal ",
          });
          shouldBlock = true;
        }
        if (!service?.service_practitioner) {
          dispatch(
            addValidationError({
              field: `services`,
              message: "please, select doctor in service",
            })
          );
          shouldBlock = true;
        }
        if (service?.diagnosis?.length === 0) {
          dispatch(
            addValidationError({
              field: `services`,
              message: "please, select Diagnosis in service",
            })
          );
          shouldBlock = true;
        }
      });
    }

    const id = stepFormData?.id;
    const identifierType = stepFormData?.identifier_type?.ident_type_id;
    console.log({ identifierType });
    const firstChar = id?.charAt(0);

    if (!id) {
      dispatch(
        addValidationError({
          field: "id",
          message: "Please enter ID or Iqama No.",
        })
      );
      shouldBlock = true;
    } else if (identifierType === 1 && firstChar !== "2") {
      dispatch(
        addValidationError({
          field: "id",
          message: "Iqama No. must start with 2",
        })
      );
      shouldBlock = true;
    } else if (identifierType === 6 && firstChar !== "1") {
      dispatch(
        addValidationError({
          field: "id",
          message: "National ID No. must start with 1",
        })
      );
      shouldBlock = true;
    } else if (
      (identifierType === 1 || identifierType === 6) &&
      id.length !== 10
    ) {
      dispatch(
        addValidationError({
          field: "id",
          message: "ID/Iqama must be 10 digits",
        })
      );
      shouldBlock = true;
    } else if (
      identifierType !== 1 &&
      identifierType !== 6 &&
      ["1", "2"].includes(firstChar)
    ) {
      dispatch(
        addValidationError({
          field: "id",
          message:
            "ID format does not match: Only National ID or Iqama should start with 1 or 2",
        })
      );
      shouldBlock = true;
    }

    if (isProfessionalEmer) {
      if (!stepFormData?.admission_date) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter Admission Date is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
      if (!stepFormData?.traiage_date) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter Triage Date is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
      if (!stepFormData?.encounter_class) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter  Class is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
      if (!stepFormData?.encounter_status) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter  Status is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
      if (!stepFormData?.emergncy_arrival_code) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter  Emergency Arrival Code is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
      if (!stepFormData?.service_event_type) {
        dispatch(
          addValidationError({
            type: "Encounter",
            message:
              "Encounter Service Event Type is required for Professional Emergency claims",
          })
        );
        shouldBlock = true;
      }
    }
    const totalSize = calculateTotalAttachmentSize(
      attachments,
      investigationAttachment
    );
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB
    console.log({ totalSize });
    if (totalSize > maxSizeBytes) {
      dispatch(
        addValidationError({
          field: "attachments",
          message:
            "The total size of all attachments and investigation result exceeds the maximum limit of 10MB. Please compress your files or remove some attachments to proceed.",
        })
      );
      shouldBlock = true;
    }
    const maxSize = 10 * 1024 * 1024;
    if (stepFormData?.investigation_result_attachment?.size > maxSize) {
      dispatch(
        addValidationError({
          field: "manual",
          message: "The file Can't be more 10 Mb",
        })
      );
      shouldBlock = true;
    }

    // if (
    //   !allowedTypes.includes(
    //     stepFormData?.investgation_result_attachment?.contentType
    //   )
    // ) {
    //   dispatch(
    //     addValidationError({
    //       field: "manual",
    //       message: "Only PDF or image files are allowed",
    //     })
    //   );
    //   shouldBlock = true;
    // }
    if (
      stepFormData?.investgation_result?.investreslttype_code === "IRA" &&
      !stepFormData?.investgation_result_attachment
    ) {
      dispatch(
        addValidationError({
          type: "manual",
          message: "Attachment is required",
        })
      );
      shouldBlock = true;
    }

    console.log({ shouldBlock });

    if (shouldBlock) {
      toast.error("Please, fix all validation issues in remarks tab.");
      setActiveKey("claim_issues");
      return;
    }

    const requestBody = buildRequestBody({
      stepFormData,
      selectedBranch,
      attachements: stepFormData?.attachments,
      practitionerListAdded,
      preauthorizationDiagnosis,
      labTestList,
      cliamServicesList,
      isDental,
      isPharmacy,
      isPrescription,
      isSubmit,
    });

    // console.log({ requestBody });
    // return;
    const response = await dispatch(CreateSingleClaim(requestBody)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.claimsList);
      dispatch(handleResetCreateClaim());
    } else {
      toast.error("Submission Failed, try again");
    }
  };

  return (
    <>
      {Number(claimsSetting?.view) === 1 ? (
        <FalconComponentCard
          className="shadow-md"
          style={{ position: "relative" }}
        >
          <FalconComponentCard.Header
            className="d-flex fixed-header  justify-content-between align-items-center"
            sx={{
              position: "sticky !important",
              top: 68,
              zIndex: 1020,
              backgroundColor: "white",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <BackButton
              path={paths.claimsList}
              title={`View Claim Request - (${viewClaimInfo?.claim_id})`}
            />

            <Col xs="auto" className="d-flex gap-2">
              {saveStatus && Number(claimsSetting?.submit) === 1 && (
                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => handleSaveSubmit(false)}
                >
                  Save/Update
                </Button>
              )}
            </Col>
          </FalconComponentCard.Header>
          <FalconComponentCard.Body
            style={{
              marginTop: "40px",
              overflowY: "auto",
              maxHeight: "calc(100vh - 200px)",
            }}
          >
            <ClaimsViewRequestDetails
              setActiveKey={setActiveKey}
              activeKey={activeKey}
            />
          </FalconComponentCard.Body>
        </FalconComponentCard>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view this claim request.
          </p>
        </div>
      )}
      <ClaimMedicalHistoryModal
        show={historyModalOpen}
        onHide={() => dispatch(setHistoryModal(false))}
      />
      <ClaimBatchCheckModal
        body={body}
        setBody={setBody}
        data={data}
        modal={showClaimModal}
        setModal={setShowClaimModal}
        setClaimNo={setClaimNo}
      />
    </>
  );
};

export default ClaimViewRequest;
